import { Component, type ErrorInfo, type ReactNode } from "react"
import { FormattedMessage } from "react-intl"
import { enUSMessages } from "../i18n/messages"

type Props = {
  children: ReactNode
}

type State = {
  error: Error | null
}

export class RouteErrorBoundary extends Component<Props, State> {
  constructor(props: Props) {
    super(props)
    this.state = { error: null }
  }

  static getDerivedStateFromError(error: Error): State {
    return { error }
  }

  componentDidCatch(error: Error, info: ErrorInfo) {
    console.error("Route render error", error, info.componentStack)
  }

  handleReset = () => {
    this.setState({ error: null })
  }

  render() {
    const { error } = this.state
    if (error) {
      return (
        <section className="panel panel-danger">
          <h2>
            <FormattedMessage
              defaultMessage={enUSMessages["error.route.title"]}
              id="error.route.title"
            />
          </h2>
          <p>
            <FormattedMessage
              defaultMessage={enUSMessages["error.route.body"]}
              id="error.route.body"
            />
          </p>
          <pre className="error-trace">{error.message}</pre>
          <button
            className="secondary-button"
            onClick={this.handleReset}
            type="button"
          >
            <FormattedMessage
              defaultMessage={enUSMessages["error.route.retry"]}
              id="error.route.retry"
            />
          </button>
        </section>
      )
    }

    return this.props.children
  }
}
